'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
  );
};
EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
EditorFormatListNumbered.muiName = 'SvgIcon';

exports.default = EditorFormatListNumbered;


//////////////////
// WEBPACK FOOTER
// ../~/material-ui/svg-icons/editor/format-list-numbered.js
// module id = ../node_modules/material-ui/svg-icons/editor/format-list-numbered.js
// module chunks = 0